export default "__VITE_ASSET__6e836e46__"